import { Component, OnInit, ViewChild } from '@angular/core';
import { UserService } from '../services/user.service';
import { MatDatepickerInputEvent, MatDialog, MatPaginator, MatSort, MatTableDataSource } from '@angular/material';
import { TableUtil } from '../admintrademaster/tableUtil';
import * as moment from 'moment';
import { IndusindBankService } from '../services/indusindbank.service';
import { EditIndusindBankTransactionDialog } from './edit-indusind-bank-transaction/edit-indusind-bank-transaction.component';
import { ProperJsonDialogComponent } from '../properJsonDialog/properjsondialog.component';

@Component({
    selector: 'app-indusindbanktransaction',
    templateUrl: './indusindbanktransaction.component.html',
    styleUrls: ['./indusindbanktransaction.component.css']
})

export class IndusindBankTransactionsComponent implements OnInit {
    displayedColumns = [
        'data',
        'user_name',
        'request_ID',
        'challanCode',
        'challan_no',
        'clientAccountNo',
        'clientName',
        'amount',
        'remitterName',
        'remitterAccountNo',
        'remitterIFSC',
        'remitterBank',
        'remitterBranch',
        'remitterUTR',
        'payMethod',
        'creditAccountNo',
        'inwardRefNum',
        'creditTime',
        'reserve1',
        'reserve2',
        'reserve3',
        'reserve4',
        'createdAt',
        'is_process',
        'note',
    ];
    fromDate;
    toDate;
    filter: any = {};
    public selectedDate = new Date();
    public selectedDate1 = new Date();
    dataSource: MatTableDataSource<indusindBankData>;
    pageSize = 10;
    pageSizeOptions = [5, 10, 25, 50, 100];
    @ViewChild(MatPaginator) paginator: MatPaginator;
    @ViewChild(MatSort) sort: MatSort;
    constructor(
        private userService: UserService,
        private indusindBank: IndusindBankService,
        public dialog: MatDialog
    ) { }

    ngOnInit() {
        this.csrf();
        this.applyRefreshData();
        this.filter['fDate'] = moment(this.selectedDate).format('yyyy-MM-DD');
        this.filter['tDate'] = moment(this.selectedDate1).format('yyyy-MM-DD');
    }
    fromDateFilter(type: string, event: MatDatepickerInputEvent<Date>) {
        this.fromDate = moment(event.value).format('yyyy-MM-DD');
        this.filter['fDate'] = this.fromDate;
    }
    async toDateFilter(type: string, event: MatDatepickerInputEvent<Date>) {
        this.toDate = moment(event.value).format('yyyy-MM-DD');
        this.filter['tDate'] = this.toDate;
    }
    applyFilter(filterValue: string) {
        filterValue = filterValue.trim(); // Remove whitespace
        filterValue = filterValue.toLowerCase(); // Datasource defaults to lowercase matches
        this.dataSource.filter = filterValue;
    }
    async applyRefreshData() {
        this.userService.csrf().subscribe(data => {
            this.filter['_csrf'] = data._csrf;
            this.indusindBank.getIndusindBankTransactions(this.filter).subscribe((success) => {
                let indusindBankRes = success.map(indusindBankTrans => {
                    indusindBankTrans.user_name = indusindBankTrans.userid ? indusindBankTrans.userid.name :  '';
                    indusindBankTrans.createdAt = moment(indusindBankTrans.createdAt).format('MM/DD/YY h:mm:ss A');
                    return indusindBankTrans;
                })
                this.dataSource = new MatTableDataSource(indusindBankRes);
                this.dataSource.paginator = this.paginator
                this.dataSource.sort = this.sort;
            })
        })
    }
    async exportArray() {
        if (this.dataSource.filteredData) {
            const indusindbankaudit = await this.dataSource.filteredData.map(x => ({
                'User Name' : x.user_name,
                'Request ID' : x.request_ID,
                'Challan Code' : x.challanCode,
                'Challan Number' : x.challan_no,
                'Client Account Number' : x.clientAccountNo,
                'Client Name' : x.clientName,
                'Amount' : x.amount,
                'Remitter Name' : x.remitterName,
                'Remitter AccountNo' : x.remitterAccountNo,
                'Remitter IFSC' : x.remitterIFSC,
                'Remitter Bank' : x.remitterBank,
                'Remitter Branch' : x.remitterBranch,
                'Remitter UTR' : x.remitterUTR,
                'Pay Method' : x.payMethod,
                'Credit Account No' : x.creditAccountNo,
                'Inward Ref Number' : x.inwardRefNum,
                'Credit Time' : x.creditTime,
                'Reserve1' : x.reserve1,
                'Reserve2' : x.reserve2,
                'Reserve3' : x.reserve3,
                'Reserve4' : x.reserve4,
                "Created At": x.createdAt,
                "Is Process": x.is_process,
                "Note": x.note,
            }));
            TableUtil.exportArrayToExcel(indusindbankaudit, "indusindbanktrans");
        }

    }
    csrf() {
        this.userService.csrf().subscribe((success) => this.filter['_csrf'] = success._csrf)
    }

    displayProperJson(jsonData) {
        let obj = {
            jsonData: jsonData,
        }
        this.dialog.open(ProperJsonDialogComponent, {
            width: 'auto',
            height: 'auto',
            data: obj,
        }).afterClosed().subscribe(result => {
        });
    }
    editIndusindBankTransaction(element) {
        if(element.userid == null){
          this.dialog.open(EditIndusindBankTransactionDialog, {
            width: 'auto',
            data: element,
        }).afterClosed().subscribe(result => {
            if (result) {
              this.applyRefreshData();
            }
        });
        }else{
            
        }
      }
}
export interface indusindBankData {
    data: string,
    user_name: string,
    request_ID: string,
    challanCode: string,
    challan_no: string,
    clientAccountNo: string,
    clientName: string,
    amount: string,
    remitterName: string,
    remitterAccountNo: string,
    remitterIFSC: string,
    remitterBank: string,
    remitterBranch: string,
    remitterUTR: string,
    payMethod: string,
    creditAccountNo: string,
    inwardRefNum: string,
    creditTime: string,
    reserve1: string,
    reserve2: string,
    reserve3: string,
    reserve4: string,
    createdAt: string,
    is_process: string,
    note: string,
} 


// WEBPACK FOOTER //
// ./src/app/indusindbanktransactions/indusindbanktransaction.component.ts